export default __webpack_public_path__ + "static/apple_podcast-c08006a1eed2b83620ab36ed8e5751cb.svg";